import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";var _excluded = ["currentStepIndex", "steps"];import React from 'react';
import {
  ProgressSteps_Circle,
  ProgressSteps_Content,
  ProgressSteps_Label,
  ProgressSteps_Root,
  ProgressSteps_Segment,
  ProgressSteps_Spacer,
  ProgressSteps_Track } from
'./ProgressSteps.styles';

/**
 * @typedef ProgressStepsProps
 * @property {number} [currentStepIndex] Index of the currently active step.
 * @property {string[]} steps Array of labels to display in the progress bar.
 */

/**
 * A horizontal progress bar with stop points defined by an array of steps.
 * @param {ProgressStepsProps} props
 */
export var ProgressSteps = function ProgressSteps(props) {
  var _props$currentStepInd =



    props.currentStepIndex,currentStepIndex = _props$currentStepInd === void 0 ? 0 : _props$currentStepInd,steps = props.steps,otherProps = _objectWithoutProperties(props, _excluded);

  if (!Array.isArray(steps) || steps.length < 2) {
    console.error('ProgressSteps: The `steps` prop needs to be an array with at least 2 steps.');
    return null;
  }

  var lastStep = steps.length - 1;

  return /*#__PURE__*/(
    React.createElement(ProgressSteps_Root, otherProps, /*#__PURE__*/
    React.createElement("ol", null,
    steps.map(function (step, index) {return /*#__PURE__*/(
        React.createElement(ProgressSteps_Segment, {
          "aria-current": index === currentStepIndex ? 'step' : undefined,
          key: step || index },

        index > 0 && /*#__PURE__*/
        React.createElement(ProgressSteps_Spacer, null, /*#__PURE__*/
        React.createElement(ProgressSteps_Track, null)
        ), /*#__PURE__*/

        React.createElement(ProgressSteps_Content, null, /*#__PURE__*/
        React.createElement(ProgressSteps_Circle, null), /*#__PURE__*/
        React.createElement(ProgressSteps_Track, null), /*#__PURE__*/
        React.createElement(ProgressSteps_Label, null,
        step
        )
        ),
        index < lastStep && /*#__PURE__*/
        React.createElement(ProgressSteps_Spacer, null, /*#__PURE__*/
        React.createElement(ProgressSteps_Track, null)
        )

        ));}
    )
    )
    ));

};
//# sourceMappingURL=ProgressSteps.js.map